module.exports = __webpack_public_path__ + "img/astral_9.ec1f4944.svg";